var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { List, Message } from "semantic-ui-react";
var ErrorDisplay = /** @class */ (function (_super) {
    __extends(ErrorDisplay, _super);
    function ErrorDisplay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.filteredErrorMessages = function (path) {
            return _this.props.errors.filter(function (e) { return e.path === path; })
                .map(function (e) { return e.msg; });
        };
        return _this;
    }
    ErrorDisplay.prototype.render = function () {
        var msgs = this.filteredErrorMessages(this.props.errorPath);
        var retVal;
        if (msgs.length > 0) {
            retVal = React.createElement(Message, { error: true },
                React.createElement(List, { items: msgs }));
        }
        else {
            retVal = '';
        }
        return retVal;
    };
    return ErrorDisplay;
}(React.PureComponent));
export default ErrorDisplay;
//# sourceMappingURL=ErrorDisplay.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/ErrorDisplay.js
// module id = 18
// module chunks = 0